import React from 'react';
import Navigation from '../../Home/Navigation/Navigation';


const Projects = () => {
    return (
        <div>
            <Navigation></Navigation>
            This is projects page
        </div>
    );
};

export default Projects;